import React, { useState } from 'react';
import { withRouter, WithRouterProps } from 'react-router';
import Pluralize from 'pluralize';
import { renderReuseClassButton, renderRemoveClassButton } from './GroupEditPanel';
import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import GroupMemberships from 'collections/GroupMemberships';
// @ts-ignore
import GroupActions from 'groups/actions/GroupActions';
// @ts-ignore
import GroupName from 'groups/components/GroupName';
// @ts-ignore
import GroupLeaveConfirmDialog from 'groups/components/GroupLeaveConfirmDialog';
import GroupMemberListItem from 'groups/components/GroupMemberListItem';
import BoxBody from 'components/BoxBody';
// @ts-ignore
import { unaffiliatedOrgOption } from 'groups/components/GroupSchoolSelect';
// @ts-ignore
import ScrollableArea from 'components/ScrollableArea';
// @ts-ignore
import Divider from 'components/Divider';
import MediaObject from 'components/MediaObject';
import BoxHeader from 'components/BoxHeader';
import ModalTrigger from 'components/ModalTrigger';
import Button from 'components/Button';
import Row from 'components/Row';
import TitleHeader from 'components/TitleHeader';
import Text from 'components/Text';

import './styles/GroupSettingsTab.scss';

import {
  Props as GroupRenderProps,
  renderGroupOwnerManagerPanel,
  renderGroupInformationPanel,
} from './GroupSettingsRenderMethods';

type Props = {
  group: Group;
  onCodeChange: Function;
  refetch?: () => void;
};

function _GroupSettingsTab(props: Props & WithRouterProps) {
  const { group, onCodeChange, router, refetch } = props;
  const [stateGroup, setStateGroup] = useState({
    name: group.getName(),
    code: group.getCodeOrError(),
    orgId: '',
  });

  const userIsTeacher = CurrentUser.getUser().isTeacher();

  const currentOrg = group.getOrganization();
  const currentOrgOption = currentOrg
    ? {
        value: currentOrg.id.toString(),
        label: currentOrg.getName(),
      }
    : unaffiliatedOrgOption;

  if (group.canEdit()) {
    return (
      <ScrollableArea className="GroupSettingsTab">
        <div className="GroupSettingsTab-content">
          <BoxBody flush className="GroupSettingsTab-content-settingsTitle">
            <TitleHeader title="Class information" textAlign="left" flush />
          </BoxBody>

          {renderGroupInformationPanel({
            group,
            onCodeChange,
            userIsTeacher,
            isSettingsTab: true,
          })}

          <BoxHeader
            title="Class owners"
            textAlign="left"
            subtext="Class owners can see and send messages to class participants.  Once somebody becomes a class owner, they cannot be removed."
          />

          <div className="GroupSettingsTab-content-owners">
            {renderGroupOwnerManagerPanel(props.group, refetch)}
          </div>

          <BoxBody flush>
            <Divider size="flush" />
          </BoxBody>

          <div>
            <BoxHeader title="Archiving" textAlign="left" />
            <BoxBody className="GroupSettingsTab-content-archive">
              <MediaObject>
                {
                  <div style={{ maxWidth: 225 }}>
                    {renderReuseClassButton(group, router, () => {}, true)}
                  </div>
                }
                {
                  <div style={{ maxWidth: 225 }}>
                    {renderRemoveClassButton(group, router, () => {}, true)}
                  </div>
                }
              </MediaObject>
            </BoxBody>
          </div>
        </div>
      </ScrollableArea>
    );
  } else {
    const owners = group.getOwners() as GroupMemberships;
    const ownerNames = owners.map((o: any) => o.getUser().getName());
    const groupName = <GroupName group={group} />;

    const leaveButtonOpt = group.canLeave() && (
      <Row size="xsmall">
        <div className="GroupSubscribedTabSettingModal-actionBox">
          <Row size="small">
            <ModalTrigger modal={<GroupLeaveConfirmDialog group={group} onLeave={() => {}} />}>
              <Button data-test-selector="leave_class_button" level="secondary" color="lava">
                Leave class
              </Button>
            </ModalTrigger>
          </Row>
          <Text color="thunder">You will no longer receive announcements from {groupName}.</Text>
        </div>
      </Row>
    );

    return (
      <div className="GroupSettingsTab-content">
        <BoxHeader title="Information" textAlign="left" flush />
        <BoxBody>
          <div className="GroupSettingsTab-content-infoSection">
            <div className="GroupSettingsTab-content-infoHeader">Class name</div>
            {groupName}
          </div>
          <div className="GroupSettingsTab-content-infoSection">
            <div className="GroupSettingsTab-content-infoHeader">Class code</div>@
            {group.getCodeOrError()}
          </div>
          <div className="GroupSettingsTab-content-infoSection">
            <div className="GroupSettingsTab-content-infoHeader">School</div>
            {currentOrgOption.label}
          </div>
          {leaveButtonOpt}
        </BoxBody>

        <BoxBody flush>
          <Row size="small">
            <TitleHeader
              title={`Class ${Pluralize('Owner', owners.length)}`}
              subtext="Class owners can send announcements and individual messages to participants."
              textAlign="left"
              flush
            />
          </Row>
        </BoxBody>

        <ul className="GroupSettingsTab-content-owners">
          {owners.map((owner: any) => (
            <GroupMemberListItem classMember={owner} />
          ))}
        </ul>
      </div>
    );
  }
}

export const GroupSettingsTab = withRouter(_GroupSettingsTab);
